import { createSvgComponent } from "../../icon/createSvgComponent";
import Search from "@core/icon/assets/search.svg";
export default createSvgComponent(Search);